var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-4",style:(_vm.mapStyle),attrs:{"id":"map"},on:{"click":function($event){return _vm.onClick($event.target.alt)}}})}
var staticRenderFns = []

export { render, staticRenderFns }